'use client';

import { Menu } from '@mui/material';
import { CSSProperties } from 'react';

import { Search } from '../../icons';
import { styled } from '../../styles';
import { SelectGhostButtonSize } from '../SelectGhostButton/types';
import { TextField } from '../TextField';

export const SelectGhostMenu = styled(Menu)(() => ({}));

export const SelectGhostOptions = styled.div(() => ({
  minWidth: 158,
  maxHeight: 160,
  overflow: 'auto',
}));

export const SelectItem = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  width: '100%',
}));

export const SelectItemLabel = styled.span(
  () =>
    ({
      flex: 1,
      textAlign: 'start',
    } as const),
);

export const SearchIcon = styled(Search)(({ theme }) => ({
  width: '24px',
  height: '24px',
  left: theme.spacing(4),
  zIndex: 1,
  fill: theme.palette.text4,
}));

export const SearchInput = styled(TextField, {
  shouldForwardProp: (propName) => propName !== 'sizeText',
})<{ sizeText: SelectGhostButtonSize }>(({ theme, sizeText }) => ({
  width: '100%',
  outline: 'none',
  color: theme.palette.text1,

  height: 40,
  '.MuiInputBase-root': {
    height: 40,
  },
  '.MuiInputBase-input': {
    padding: theme.spacing(0),
  },

  '&::placeholder': {
    color: theme.palette.text3,
    ...(sizeText === 'small'
      ? theme.typography.label3
      : (theme.typography.body2 as CSSProperties)),
  },
  '&:placeholder-shown': {
    textOverflow: 'ellipsis',
  },
}));

export const InputWrapper = styled.div(({ theme }) => ({
  padding: theme.spacing(2),
  color: theme.palette.text3,
}));
